import { ApiDispatcherInterface } from "@app/backendApi/types";
import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useCallback,
  useContext,
} from "react";

type ApiDispatch = <R>(
  action: (dispatch: ApiDispatcherInterface["dispatch"]) => Promise<R>
) => Promise<R>;

const Context = createContext<ApiDispatch | null>(null);

export const ApiDispatchProvider: FunctionComponent<
  PropsWithChildren<{ value: ApiDispatcherInterface }>
> = ({ children, value }) => {
  const dispatch: ApiDispatch = useCallback(
    (action) => action(value.dispatch),
    [value.dispatch]
  );

  return <Context.Provider value={dispatch}>{children}</Context.Provider>;
};

export const useApiDispatch = () => {
  const ctx = useContext(Context);
  if (!ctx) {
    throw new Error(
      "useApiDispatch must be used within an ApiDispatchProvider"
    );
  }
  return ctx;
};
